import { useEffectOnce } from "./useEffectOnce";

export const useOnMount = (onMount: () => void) =>
  useEffectOnce(() => {
    if (onMount) {
      onMount();
    }
  });
